import React, { createContext, useState } from 'react'

export const HighlightedColumnsContext = createContext()
export const DEFAULT_AREA = { init: null, start: null, end: null }

const HighlightedColumnsProvider = ({ children }) => {
  const [area, setArea] = useState(DEFAULT_AREA)

  return (
    <HighlightedColumnsContext.Provider value={{ area, setArea }}>
      {children}
    </HighlightedColumnsContext.Provider>
  )
}

export default HighlightedColumnsProvider
